import * as martinez from 'martinez-polygon-clipping';
import { EuroCylinderHoleAu } from '../__generated/model/index.js';
import { createCirclePolygon, createRectPolygon } from './shapes.js';
export const createEuroCylinderHolePolygon = (hole)=>{
    const { type, $absCoords: { x, y }, topWidth, bottomWidth, height } = hole;
    const isAustralian = type === EuroCylinderHoleAu.type;
    const bottomCircleRadius = isAustralian ? bottomWidth / 2 : topWidth / 2;
    const topCircleRadius = isAustralian ? topWidth / 2 : bottomWidth / 2;
    const heightHalf = height / 2;
    const topCircleY = y + heightHalf - topCircleRadius;
    const bottomCircleY = y - heightHalf + bottomCircleRadius;
    // For some very weird reason, the martinez library incorrectly unions all the sub-shapes
    // unless we make the rect between the two circles a tiny bit taller than it should be.
    const rectHeight = Math.abs(topCircleY - bottomCircleY) + 0.001;
    const rectWidth = Math.min(topWidth, bottomWidth);
    const rectY = topCircleY - rectHeight / 2;
    const topCircle = createCirclePolygon({
        center: {
            x,
            y: topCircleY
        },
        radius: topCircleRadius
    });
    const rect = createRectPolygon({
        center: {
            x,
            y: rectY
        },
        width: rectWidth,
        height: rectHeight
    });
    const bottomCircle = createCirclePolygon({
        center: {
            x,
            y: bottomCircleY
        },
        radius: bottomCircleRadius
    });
    const allShapes = [
        topCircle,
        rect,
        bottomCircle
    ];
    return allShapes.reduce(martinez.union);
};

//# sourceMappingURL=euro-cylinder-hole.js.map